import { render, staticRenderFns } from "./chooseType.vue?vue&type=template&id=b0e2c74a&scoped=true&"
import script from "./chooseType.vue?vue&type=script&lang=js&"
export * from "./chooseType.vue?vue&type=script&lang=js&"
import style0 from "./chooseType.vue?vue&type=style&index=0&id=b0e2c74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e2c74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0e2c74a')) {
      api.createRecord('b0e2c74a', component.options)
    } else {
      api.reload('b0e2c74a', component.options)
    }
    module.hot.accept("./chooseType.vue?vue&type=template&id=b0e2c74a&scoped=true&", function () {
      api.rerender('b0e2c74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/createform/components/chooseType/chooseType.vue"
export default component.exports